import {SimpleEntity} from "../simple-entity.model";
import {WhStockModel} from "./wh-stock.model";

export class WhForwardingPackEditModel {
  id: number;
  whStock: WhStockModel;
  whProduct: SimpleEntity;
  quantity: number;
  photo: string;
}
